const messages = {
    success: {
        // Company
        createCompany: 'Company created successfully',
        updateCompany: 'Company updated successfully',
        deleteCompany: 'Company deleted successfully',
        updateSubscription: 'Subscriptions updated successfully',
        updatePassword: 'Password changed successfully.',

        // User
        createUser: 'User created successfully',
        updateUser: 'User profile updated successfully',
        archiveUser: 'User archived successfully',
        unarchiveUser: 'User unarchived successfully',
        inviteUser: 'User invited successfully',

        // Content
        createContent: 'Content created successfully',
        updateContent: 'Content updated successfully',
        archiveContent: 'Content archived successfully',

        // Cohort
        cohortUpload: 'uploaded successfully',
        cohortExport: 'File downloaded successfully',
        deleteCohort: 'Cohort archived successfully',
        deleteNotification: 'Notification archived successfully',
        updateCohortMember: 'Member updated successfully',
        mergeCohortMember: 'Cohort merged successfully',
        scheduleCohort: 'Cohort scheduled successfully',

        // Program management
        archiveProgram: 'Program archived successfully',
        copyProgram: 'Program copied successfully',
        addProgram: 'New program created successfully',
        updateProgram: 'Program updated successfully',

        //System Notifications
        archiveNotifications: 'Notifications archived successfully',

        // Advisory Group
        updateMeeetingDetails: 'Meeting details updated successfully',
        addMeetingLocation: 'Meeting location added successfully',
        updateMeetingLocation: 'Meeting location updated successfully',
        updateMeetingPreResponseStatus: 'Pre-meeting response updated successfully',
        updateMeetingAttendancePostStatus: 'Meeting attendance status updated successfully',
        updateMeetingStatusDocumented: 'Meeting documentation status updated successfully',
        addAttendanceLog: 'Attendance details added successfully',
        updateAttendanceLogData: 'Attendance details updated successfully',
        updateAdvisoryGroupDetail: 'Advisory Group details updated successfully',
        addPortal: 'Advisory Group portal details added successfully',
        updatePortal: 'Advisory Group portal details updated successfully',
        archiveRecruitmentMembers: 'Members archived successfully',
        addRosterComment: 'Comment added successfully',
        AddMeeting: 'Meeting added successfully',
        addMeetingLocationSupportStaff: 'Meeting location host added successfully',
        addCaregiver: 'Caregiver added successfully',
        updateCaregiver: 'Caregiver updated successfully',
        archiveCaregiver: 'Caregiver archived successfully',
        caregiverStatus: 'Caregiver details updated successfully',
        cancelMeeting: 'Meeting cancelled successfully.',
        onboardingStatusMessage: 'Member onboarding statuses updated successfully',

        // AG Recruitment Application
        updateMemberRecord: 'Member record updated successfully',
        retireMember: 'Member has been successfully Retired',
        updateApplication: 'Recruitment Application updated successfully',
        addComment: 'Member comment added successfully',
        updateRecruitingOutreach: 'Recruitment Outreach updated successfully',
        deleteOutreachComment: 'Comment deleted successfully',
        addOutreachComment: 'Comment added successfully',
        deleteMemberComment: 'Member comment deleted successfully',
        updateProxyDetails: 'Proxy Attendee details updated successfully.',
        updateOutreachDetails: 'Recruitment Outreach details updated successfully.',

        // Panel Selection and Maintenance
        updatePanelSelection: 'Panel selection updated successfully',
        noUpdatesPanelSelection: 'Panel selection updates have been discarded',
        noUpdatesProcessApplication: 'Application process updates have been discarded',

        // Panel Maintenance
        updatePanelMaintenance: 'Panel updated successfully',
        noUpdatesPanelMaintenance: 'Panel updates have been discarded',

        // Meeting
        archiveMeetingLocation: 'Meeting location cancelled successfully',

        // Support Staff
        addSupportStaff: 'Support staff record added successfully',
        updateSupportStaff: 'Support staff record updated successfully',
        archiveSupportStaffMembers: 'Support staff member archived successfully',
        addSupportStaffComment: 'Comment added successfully',
        supportStaffAssign: 'Support staff successfully assigned to the meeting',
        updateSupportStaffAssigned: 'Assigned support staff updated successfully',
        cancelSupportStaffAssigned: 'Assigned support staff cancelled successfully',

        // Non Members
        addNonMember: 'Non-Member added successfully',
        updateNonMember: 'Non-Member updated successfully',
        archiveNonMember: 'Non-Member archived successfully',
        addNonMemberAttendance: 'Non-Member attendance added successfully',
        updateNonMemberAttendance: 'Non-Member attendance updated successfully',
        addNonMemberComment: 'Comment added successfully',

        // Document
        addDocument: 'Document uploaded successfully',
        updateDocument: 'Document updated successfully',
    },
    error: {
        // General
        prefix: 'Error:',
        fileNotFound: 'File not found',
        pngExportError: 'PNG export failed',

        // Cohort
        cohortUpload: 'Error in uploading',
        cohortNameValidation: 'Cohort name should not be empty and should not have a leading or trailing white space or multiple spaces.',
        cohortMemberInvalid: 'Cohort member id does not exist',
        cohortDemographicsLoadFailed:
            'Could not load cohort member demographics for this augmented member. You can still close this window or retry after refreshing.',

        // Program management
        copyProgram: 'Error copying program',
        addProgram: 'Error creating new program',
        updateProgram: 'Error updating program',
        updateAdvisoryGroup: 'Error updating Advisory Group',

        //System Notifications
        archiveNotifications: 'Error archiving notifications',

        // Support Staff
        locationAssign: 'Location not assigned to all selected support staff',
    },
    confirm: {
        // Company
        deleteCompany: 'Upon archiving this Company, all users and meeting related content associated to this Company will also be archived.',

        // Content
        archiveContent: 'Are you sure you want to archive the content?',

        // User
        archiveUser: 'Are you sure you want to archive the user?',
        unarchiveUser: 'Are you sure you want to unarchive the user?',

        // Cohort
        deleteCohort: 'Are you sure you want to archive the cohort?',
        deleteNotification: 'Are you sure you want to archive the notification?',
        noFileSelected: 'Please select a file before submitting.',

        // Program
        archiveProgram: 'Are you sure you want to archive the program?',
        discardProgramEdit: 'All unsaved changes will be lost. Are you sure you want to continue?',

        //Recruitment
        discardProxyEdit: 'All unsaved changes will be lost. Are you sure you want to continue?',
        panelAugmentationConfirm:
            'This will rank the cohort against the current panel and add up to 100 augmented placeholder members. Continue?',

        // System notifications
        archiveNotifications: 'Are you sure you want to archive these notifications?',

        // Meeting
        archiveMeetingLocation: 'Are you sure you want to archive the meeting location?',

        // Advisory Group
        archiveRecruitmentMember: 'Are you sure you want to archive these members?',

        // Support Staff
        archiveSupportStaff: `Selected records will be archived.`,
        discardSupportStaffAssign: 'All unsaved changes will be lost. Are you sure you want to continue?',
        cancelSupportStaff: 'Are you sure you want to remove the support staff from the meeting?',

        // Caregiver
        archiveCaregiver: 'Are you sure you want to archive the Caregiver?',
        updateGuardian: 'Guradian caregiver already exists. Are you sure you want to change the Guardian?',

        // Non Members
        archiveNonMember: 'Are you sure you want to archive the non member?',
    },
    info: {
        // Cohort
        mergeCohortNoRecord: 'No validated cohorts available',
        agRecruitingAlert: 'Currently no members are available to invite or onboard. Please go to the Panel Selection page and select members to add to your AG',
        checkJfifFile: 'JFIF files are not allowed.',
        memberRecordErrorInfo:"Please Contact a System Admin for help editing this Member Record",
        cancelMeeting: 'The meeting cannot be canceled because one or more members have been marked as Attended.',
        ellipseOverlapNoRecordMessage: 'All panel participants live outside the population ellipse.',
        panelCandidateRankingTooltip:
            'Panel fit score (0–100) estimates how much adding this participant would improve how closely the advisory group matches your cohort target profile. The model considers weighted attributes such as language, age, gender, race/ethnicity, geography, and other factors configured for your program. The list is ordered with the highest scores first. Row colors match the bar above: red 0–49 (Non Representative), orange 50–74 (Partially Representative), yellow 75–89 (Minimally Representative), green 90–100 (Representative).',
        panelCandidateRankingBandsLegend:
            'Band colors: red (non-representative) through green (representative), matching the progress bar above.',
        panelGapsLowSampleWarning:
            'The current panel has few members, so gap estimates are directional only—not precise percentages.',
        panelGapsAgeQuartilesExplainer:
            'Age bands Q1–Q4 are quartiles within your cohort (from youngest 25% of members to oldest 25%), not fixed national age brackets. Exact year ranges appear here when the service includes cohort age cutpoints on this response.',

        // Autofill application form
        autoFillSelectedMember: 'The form is autofilled with data from the selected member record.',
        autoFillExactMatch: 'We found an exact match and automatically populated the available member information below.',
        autoFillSelectFromMultiple: 'Please review and select the correct member. If none of these match, please proceed with filling out the application form.',
        autoFillNoMatch: 'Unfortunately, we could not find this member. Please proceed with filling out the below application form.'

    }
}

export default messages;
